import ZDData from './ZDData'
import DocsCard from './components/DocsCard/DocsCard'

export { ZDData, DocsCard }
